var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isInterested
      ? _c(
          "div",
          { staticClass: "mt-4" },
          [
            !_vm.successfullyAccepted
              ? [
                  _c("h3", { staticClass: "color-primary" }, [
                    _vm._v("Du bist noch anonym!")
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "Deine persönlichen Daten (wie Namen, bisherige Arbeitgeber, Wohnort, usw.) sind noch nicht\n\t\t\t\tsichtbar.\n\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-3" }, [
                    _c("div", [_vm._v("Dein Interesse am Jobprofil:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "font-weight-extra-bold" }, [
                      _vm._v(_vm._s(_vm.message.jobProfile.info))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-3" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.customerName) +
                        " von " +
                        _vm._s(_vm.companyName) +
                        "\n\t\t\t\t"
                    ),
                    _vm.customerWebsite
                      ? _c("span", [
                          _vm._v("("),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.customerWebsite,
                                target: "_blank"
                              }
                            },
                            [_vm._v(_vm._s(_vm.customerWebsite))]
                          ),
                          _vm._v(")")
                        ])
                      : _vm._e(),
                    _vm._v("\n\t\t\t\that dir die Anfrage gesendet."),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\tDer Job ist noch nicht besetzt! Um Hintergrundinformationen zur Stelle zu erfahren und deine Chancen\n\t\t\t\tzu sichern, bestätige bitte umgehend die Kontaktanfrage."
                    ),
                    _c("br"),
                    _vm._v(
                      " " +
                        _vm._s(_vm.customerName) +
                        "\n\t\t\t\tvon " +
                        _vm._s(_vm.companyName) +
                        " wird informiert und meldet sich über skilldoo bei dir.\n\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isNotInterested
      ? _c("div", { staticClass: "mt-4" }, [
          _c("h3", [_vm._v("Verabschiedung")]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-2" }, [
            _vm._v("\n\t\t\tDieses Jobprofil "),
            _c("span", { staticClass: "font-weight-extra-bold" }, [
              _vm._v(_vm._s(_vm.message.jobProfile.info))
            ]),
            _vm._v(
              "\n\t\t\twurde angezeigt, weil es eine entsprechende Übereinstimmung mit deinem Jobwunsch gibt."
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\tDamit in Zukunft noch genauer die für dich passenden Jobs angezeigt werden, passe bitte dein\n\t\t\tWunschprofil an.\n\t\t"
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isCustomerUninteresting
      ? _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c("ApplicantSendOff", {
              attrs: { customer: _vm.message.customer },
              on: { input: _vm.applicantSendoffDataChanged },
              model: {
                value: _vm.applicantSendoffData,
                callback: function($$v) {
                  _vm.applicantSendoffData = $$v
                },
                expression: "applicantSendoffData"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3 font-size-small" }, [
      _vm._v(
        '\n\t\t\t\tWenn du auf "Kontaktanfrage bestätigen" drückst, werden von deinem Profil folgende Daten\n\t\t\t\toffengelegt:'
      ),
      _c("br"),
      _vm._v("\n\t\t\t\tVorname, Nachname und Geburtsjahr."),
      _c("br"),
      _vm._v(" "),
      _c("u", [_vm._v("Nicht")]),
      _vm._v(
        " offengelegt werden deine Telefonnummer, E-Mail Adresse, genauer Wohnort (Postleitzahl,\n\t\t\t\tStraße, Hausnummer).\n\t\t\t"
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }